import React from 'react';
import {ShippingRegion} from "../types/types";

interface RegionDropdownProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: () => void;
  regions: ShippingRegion[];
  error?: string;
  required?: boolean;
}

const RegionDropdown: React.FC<RegionDropdownProps> = ({ value, onChange, onBlur, regions, error, required = false }) => (
  <div className="mt-2">
    <label htmlFor="province" className="sr-only block text-sm font-medium text-gray-700">
      Region
    </label>
    <select
      id="province"
      name="province"
      autoComplete="address-level1"
      className={`invalid:text-gray-400 relative block p-3 rounded-full w-full border-0 bg-transparent text-gray-900 ring-1 ring-inset ${error ? "ring-red-300 focus:ring-red-300" : "ring-gray-300 focus:ring-gray-300"} focus:z-10 focus:ring-4 focus:ring-inset sm:text-sm sm:leading-6`}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      required={required}
      aria-invalid={error ? "true" : "false"}
    >
      <option disabled value="">Region</option>
      {regions.map((region) => (
        <option key={region.code} value={region.code}>
          {region.label}
        </option>
      ))}
    </select>
    {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
  </div>
);

export default RegionDropdown;
